import React, { Component } from 'react';
import LadderLogoComponent from 'react/match/LadderLogoComponent.jsx';
import { CircleLoaderComponent } from 'react/CircleLoaderComponent.jsx';
import MatchHistoryPlayerComponent from './MatchHistoryPlayerComponent';
import MatchHistoryTableLink from './MatchHistoryTableLink';
import { StageComponent } from "../StageComponent";
import MatchSelectedCharactersComponent from "./active/MatchSelectedCharactersComponent";

class MatchHistoryMatchComponent extends Component {
	static defaultProps = {
		match: null,
		perspectivePlayer: null,
	};

	constructor(props) {
		super(props);
		const { match } = this.props;
		this.state = {
			isLoading: match && match.isLoading
		};
		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		const { onClick, match } = this.props;
		if(onClick) {
			onClick(e, match);
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.match && this.state.isLoading != this.props.match.isLoading) {
			this.setState({
				isLoading: this.props.match.isLoading
			});
		}
	}

	defaultMainLink() {
		const { match } = this.props;
		return (
			<MatchHistoryTableLink
				className='full_match_details'
				url={match.getUrl()}
			>
				View Full Match Details
			</MatchHistoryTableLink>);
	}

	defaultSubtitleOne() {
		const { match } = this.props;
		if(!match) {
			return null;
		}
		return (
			<span className='when'
			      title=''
			>
				{match.startTimeCalendar()}
			</span>
		);
	}

	defaultSubtitleTwo() {
		const { match } = this.props;
		return (
			<span className='duration'>
				{match && match.duration}
			</span>
		);
	}

	render() {
		const { match, players, stream, streamType, horizontalPlayers, subtitleOne, subtitleTwo, onClick, perspectivePlayer, showMatchStatusAlways } = this.props;
		const { isLoading } = this.state;
		const imageRounded = streamType === 'twitch';

		const mainLink = this.props.mainLink || this.defaultMainLink();
		const subtitleOneDisplay = subtitleOne === undefined ? this.defaultSubtitleOne() : subtitleOne;
		const subtitleTwoDisplay = subtitleTwo === undefined ? this.defaultSubtitleTwo() : subtitleTwo;

		const orderedPlayers = players && players.sort((a, b) => {
			if(a === perspectivePlayer) {
				return -1;
			}
			if(b === perspectivePlayer) {
				return 1;
			}
			return 0;
		});

		return (
			<div className='match_individual'>
				<div
					onClick={this.onClick}
					className={`match_unranked match-information ${onClick ? 'clickable' : ''}`}>
					<div className='match_details_main'>
						<div className='match_base_data'>
							{isLoading &&
							<div className='loading_display circle-loader-holder'>
								<CircleLoaderComponent />
							</div>
							}
							{!match &&
							<LadderLogoComponent
								ladder={{
									name: stream.gameData.name,
									small_image: stream.gameData.small_logo || stream.gameData.logo
								}}
							/>
							}
							{match &&
							<React.Fragment>
								<LadderLogoComponent ladder={match.ladder} />
								<div className='match_type'>
									<span className={'result_type ' + match.getTypeClass()}>
										{match.getTypeName()}
									</span>
								</div>

								{match.playerHasResult(perspectivePlayer) &&
								<div className='match_type'>
									<span
										className={`result_type ${match.playerWon(perspectivePlayer) ? 'win' : 'loss'}`}>
										{match.playerWon(perspectivePlayer) ? <span>Win</span> : <span>Loss</span>}
									</span>
								</div>
								}
								{match.disputeIsActive() &&
								<div className='match_type'>
									<span
										className='result_type disputed'>
										Disputed
									</span>
								</div>
								}
								{!!match.is_cancelled &&
								<div className='match_type'>
									<span
										className='result_type disputed'>
										Cancelled
									</span>
								</div>
								}
								{showMatchStatusAlways && match.endedNeutrally() &&
								<div className='match_type'>
									<span
										className='result_type disputed'>
										(Clean)
									</span>
								</div>
								}

								<span className='result_type type'>{match.getTeamSizeName()}</span>
								{match.match_count > 0 &&
								<div>{match.getTotalMatchesName()}</div>
								}
							</React.Fragment>
							}
						</div>
						{!!orderedPlayers &&
						<div className='secondary_match_data'>
							<div
								className={`opponents ${myUser.permissions.game_master ? 'game_master' : ''} ${horizontalPlayers ? 'horizontal' : ''}`}>
								{orderedPlayers.map((player) => (
									<MatchHistoryPlayerComponent
										key={player.id}
										match={match}
										matchPlayer={match.players[player.id]}
										ladderId={match.ladder_id}
									/>
								))}
							</div>
						</div>
						}
						{match && !!match.games &&
						<div className='match_scores'>
							{match.games.map((game) => (
								<div
									className='game_score'
									key={game.id}
								>
									<div
										className='stage_result'>
										<div
											key={game.id}
											className='stage_pick'>
											<StageComponent
												stage={game.stage_data}
											/>
										</div>
									</div>
									<div className='team_results'>
										<MatchSelectedCharactersComponent
											match={match}
											game={game}
											perspectivePlayer={perspectivePlayer}
											clickable={false}
											showLockControls={false}
											showCharacterNames={false}
											showPlayerNames={false}
										/>
									</div>
								</div>
							))}
						</div>
						}

						{!!stream &&
						<div className='stream_container'>
							<div
								className='image_container'>
								{!stream.preview_url &&
								<div className='no_logo'></div>
								}
								{!!stream.preview_url &&
								<img className={`stream_logo ${imageRounded ? 'rounded' : ''}`}
								     src={stream.preview_url} />
								}
							</div>
						</div>
						}
					</div>
				</div>
				<div className='match_detail_link_and_such'>
					{subtitleOneDisplay}
					{subtitleTwoDisplay}
					{mainLink}
				</div>
			</div>
		);
	}
}

export { MatchHistoryMatchComponent };